import { html } from "lit";
import { NotificationTypeName } from "../src";
import { SalutationName } from "../src/api/salutation";

export interface CreateServiceCallProps {
    /**
     * Should be displayed as multi-step form
     */
    multipleSteps?: boolean;
    /**
     * Offers a file upload in the form
     */
    fileUpload?: boolean;
    /**
     * Locale for the form
     */
    locale?: string;
    /**
     * Salutation of the user
     */
    salutation?: SalutationName;
    /**
     * First name of the user
     */
    firstName?: string;
    /**
     * Last name of the user
     */
    lastName?: string;
    /**
     * Email of the user
     */
    email?: string;
    /**
     * Phone of the user
     */
    phone?: string;
    /**
     * Notification type name
     */
    notificationTypeName?: NotificationTypeName;
    /**
     * Error numbers
     */
    errorNumbers?: string;
    /**
     * Event when the call is created
     */
    onMfServiceCallSubmit?: () => void;
    /**
     * Event when the call is canceled
     */
    onMfServiceCallCancel?: () => void;
    /**
     * disable silent auth - in that case the token must be provided via @trumpf/ux.utils
     */
    disableSilentAuth?: boolean;
}
/**
 * CreateServiceCall Form Micro Frontend
 */
export const CreateServiceCall = ({
    multipleSteps,
    fileUpload,
    locale,
    salutation,
    firstName,
    lastName,
    email,
    phone,
    notificationTypeName,
    errorNumbers,
    onMfServiceCallSubmit,
    onMfServiceCallCancel,
    disableSilentAuth
}: CreateServiceCallProps) => {
    return html`
        <mf-create-service-call
            locale="${locale}"
            salutation="${salutation}"
            first-name="${firstName}"
            last-name="${lastName}"
            email="${email}"
            phone="${phone}"
            notification-type-name="${notificationTypeName}"
            error-numbers="${errorNumbers}"
            ?multiple-steps=${multipleSteps}
            ?file-upload=${fileUpload}
            @mfServiceCallSubmit="${onMfServiceCallSubmit}"
            @mfServiceCallCancel="${onMfServiceCallCancel}"
            non-prod="true"
            ?disable-silent-auth=${disableSilentAuth}
        >
            <ux-f-sis-create-case-connector slot="connector"></ux-f-sis-create-case-connector>
        </mf-create-service-call>
    `;
};
